import React from 'react';
import '../../styles/index.scss';
import FormLayout from '../../components/formLayout';

export default function Home() {
  return <FormLayout name="Apply to Hoagie!" src="https://tally.so/embed/KYjMMg?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1">
  </FormLayout>
}
